import client from './client';

export interface DashboardStats {
  totalFamilies:     number;
  totalMembers:      number;
  activeSubscribers: number;
  cemeteryRecords:   number;
  familiesWithDues:  number;
  totalOutstanding:  number;
  certificatesIssued: number;
  // Families marked inactive — excluded from every other figure
  inactiveFamilies:  number;
  // Graves (and burial records) still on the CHURCH placeholder family
  unlinkedGraves?:   number;
  unlinkedBurials?:  number;
}

export interface TrendPoint {
  label:          string;   // e.g. "Jan 2023"
  year:           number;
  month:          number;
  totalCollected: number;
  paidCount:      number;
  unpaidCount:    number;
}

export const getDashboardStats = async (): Promise<DashboardStats> => {
  const { data } = await client.get<{ data: DashboardStats }>('/dashboard/stats');
  return data.data;
};

export const getSubscriptionTrend = async (): Promise<TrendPoint[]> => {
  const { data } = await client.get<{ data: { points: TrendPoint[] } }>('/dashboard/subscription-trend');
  return data.data.points;
};

// Dues severity buckets — its own endpoint (not bundled into getDashboardStats)
// because it scans every family across every month since Jan 2023, the same
// cost as the "Families with Dues" figure. Fetch it independently so a
// slower query never blocks the rest of the Overview page from rendering.
export interface DuesBuckets {
  behind1to2:    number;
  behind3to5:    number;
  behind6Plus:   number;
  totalWithDues: number;
}

export const getDashboardDuesBuckets = async (): Promise<DuesBuckets> => {
  const { data } = await client.get<{ data: DuesBuckets }>('/dashboard/dues-buckets');
  return data.data;
};

/* ── Charts data ─────────────────────────────────────────────── */
export interface ChartsData {
  genderSplit:        { gender: string; count: number }[];
  ageGroups:          { group: string;  count: number }[];
  yearOnYear:         { year: number; paidMonths: number; unpaidMonths: number; paidFamilies: number; unpaidFamilies: number }[];
  familiesPerAnbiyam: { name: string;  count: number }[];
  cemeteryTypes:      { type: string;  count: number }[];
  subscriptionPct:    { paidMonths: number; unpaidMonths: number; paidFamilies: number; totalFamilies: number };
  cemeterySubPct:     { paid: number; unpaid: number; total: number };
}

export const getDashboardCharts = async (): Promise<ChartsData> => {
  const { data } = await client.get<{ data: ChartsData }>('/dashboard/charts');
  return data.data;
};
